import ArrowDown from '@img/icons/arrow_down.svg';
import ArrowLeft from '@img/icons/arrow_left.svg';
import ArrowRight from '@img/icons/arrow_right.svg';
import ArrowUp from '@img/icons/arrow_up.svg';
import Bell from '@img/icons/bell.svg';
import Calendar from '@img/icons/calendar.svg';
import ChevronDown from '@img/icons/chevron_down.svg';
import ChevronLeft from '@img/icons/chevron_left.svg';
import ChevronRight from '@img/icons/chevron_right.svg';
import ChevronUp from '@img/icons/chevron_up.svg';
import CircleInfo from '@img/icons/circle_info.svg';
import CirclePlay from '@img/icons/circle_play.svg';
import CircleSuccess from '@img/icons/circle_success.svg';
import CircleWarning from '@img/icons/circle_warning.svg';
import Close from '@img/icons/close.svg';
import Download from '@img/icons/download.svg';
import Facebook from '@img/icons/facebook.svg';
import Hamburger from '@img/icons/hamburger.svg';
import Heart from '@img/icons/heart.svg';
import HeartFilled from '@img/icons/heart_filled.svg';
import Instagram from '@img/icons/instagram.svg';
import Linkedin from '@img/icons/linkedin.svg';
import Location from '@img/icons/location.svg';
import Minus from '@img/icons/minus.svg';
import MinusThick from '@img/icons/minus_thick.svg';
import Plus from '@img/icons/plus.svg';
import PlusThick from '@img/icons/plus_thick.svg';
import Search from '@img/icons/search.svg';
import Star from '@img/icons/star.svg';
import StarFilled from '@img/icons/star_filled.svg';
import Tick from '@img/icons/tick.svg';
import Twitter from '@img/icons/twitter-x.svg';
import Youtube from '@img/icons/youtube.svg';
import React from 'react';
export var SystemIcon;
(function (SystemIcon) {
    SystemIcon["ArrowDown"] = "arrow-down";
    SystemIcon["ArrowLeft"] = "arrow-left";
    SystemIcon["ArrowRight"] = "arrow-right";
    SystemIcon["ArrowUp"] = "arrow-up";
    SystemIcon["Bell"] = "bell";
    SystemIcon["Calendar"] = "calendar";
    SystemIcon["ChevronDown"] = "chevron-down";
    SystemIcon["ChevronLeft"] = "chevron-left";
    SystemIcon["ChevronRight"] = "chevron-right";
    SystemIcon["ChevronUp"] = "chevron-up";
    SystemIcon["CircleInfo"] = "circle-info";
    SystemIcon["CirclePlay"] = "circle-play";
    SystemIcon["CircleSuccess"] = "circle-success";
    SystemIcon["CircleWarning"] = "circle-warning";
    SystemIcon["Close"] = "close";
    SystemIcon["Download"] = "download";
    SystemIcon["Facebook"] = "facebook";
    SystemIcon["Hamburger"] = "hamburger";
    SystemIcon["Heart"] = "heart";
    SystemIcon["HeartFilled"] = "heart-filled";
    SystemIcon["Instagram"] = "instagram";
    SystemIcon["Linkedin"] = "linkedin";
    SystemIcon["Location"] = "location";
    SystemIcon["Minus"] = "minus";
    SystemIcon["MinusThick"] = "minus-thick";
    SystemIcon["Plus"] = "plus";
    SystemIcon["PlusThick"] = "plus-thick";
    SystemIcon["Search"] = "search";
    SystemIcon["Star"] = "star";
    SystemIcon["StarFilled"] = "star-filled";
    SystemIcon["Tick"] = "tick";
    SystemIcon["Twitter"] = "twitter";
    SystemIcon["Youtube"] = "youtube";
})(SystemIcon || (SystemIcon = {}));
export function getSvgFromSystem(icons) {
    switch (icons) {
        case SystemIcon.ArrowDown: {
            return React.createElement(ArrowDown, null);
        }
        case SystemIcon.ArrowLeft: {
            return React.createElement(ArrowLeft, null);
        }
        case SystemIcon.ArrowRight: {
            return React.createElement(ArrowRight, null);
        }
        case SystemIcon.ArrowUp: {
            return React.createElement(ArrowUp, null);
        }
        case SystemIcon.Bell: {
            return React.createElement(Bell, null);
        }
        case SystemIcon.Calendar: {
            return React.createElement(Calendar, null);
        }
        case SystemIcon.ChevronDown: {
            return React.createElement(ChevronDown, null);
        }
        case SystemIcon.ChevronLeft: {
            return React.createElement(ChevronLeft, null);
        }
        case SystemIcon.ChevronRight: {
            return React.createElement(ChevronRight, null);
        }
        case SystemIcon.ChevronUp: {
            return React.createElement(ChevronUp, null);
        }
        case SystemIcon.CircleInfo: {
            return React.createElement(CircleInfo, null);
        }
        case SystemIcon.CirclePlay: {
            return React.createElement(CirclePlay, null);
        }
        case SystemIcon.CircleSuccess: {
            return React.createElement(CircleSuccess, null);
        }
        case SystemIcon.CircleWarning: {
            return React.createElement(CircleWarning, null);
        }
        case SystemIcon.Close: {
            return React.createElement(Close, null);
        }
        case SystemIcon.Download: {
            return React.createElement(Download, null);
        }
        case SystemIcon.Facebook: {
            return React.createElement(Facebook, null);
        }
        case SystemIcon.Hamburger: {
            return React.createElement(Hamburger, null);
        }
        case SystemIcon.Heart: {
            return React.createElement(Heart, null);
        }
        case SystemIcon.HeartFilled: {
            return React.createElement(HeartFilled, null);
        }
        case SystemIcon.Instagram: {
            return React.createElement(Instagram, null);
        }
        case SystemIcon.Linkedin: {
            return React.createElement(Linkedin, null);
        }
        case SystemIcon.Location: {
            return React.createElement(Location, null);
        }
        case SystemIcon.Minus: {
            return React.createElement(Minus, null);
        }
        case SystemIcon.MinusThick: {
            return React.createElement(MinusThick, null);
        }
        case SystemIcon.Plus: {
            return React.createElement(Plus, null);
        }
        case SystemIcon.PlusThick: {
            return React.createElement(PlusThick, null);
        }
        case SystemIcon.Search: {
            return React.createElement(Search, null);
        }
        case SystemIcon.Star: {
            return React.createElement(Star, null);
        }
        case SystemIcon.StarFilled: {
            return React.createElement(StarFilled, null);
        }
        case SystemIcon.Tick: {
            return React.createElement(Tick, null);
        }
        case SystemIcon.Twitter: {
            return React.createElement(Twitter, null);
        }
        case SystemIcon.Youtube: {
            return React.createElement(Youtube, null);
        }
        default: {
            return null;
        }
    }
}
